import { FC, useEffect, useState } from 'react';
import styles from '@/pages/backend/cardCampSettings/nodeSettings/index.less';
import DragList from '@/pages/backend/cardCampSettings/nodeSettings/DragList';
import { Button, Popconfirm, Space } from 'antd';
import { DeleteOutlined, EditOutlined, MenuOutlined, PlusSquareOutlined } from '@ant-design/icons';
import ExerciseModal from '@/pages/backend/cardCampSettings/nodeSettings/exerciseCom/exerciseModal';
import { get, isEmpty } from 'lodash';
import { create32LengthUUID } from '@/utils/index';

export type ExerciseObj = {
  id: string;
  title: string;
  description?: string;
  rewardPer: number;
  selectedCategories?: string[];
  selectedNums?: number;
  regularQuestion?: string[];
};

const ExerciseCom: FC<{
  toggleIsFullScreen: (isFullScreen: boolean) => void;
  defaultValue?: any;
  onChange?: (obj: ExerciseObj[]) => void;
}> = ({ onChange, defaultValue, toggleIsFullScreen }) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [exerciseList, setExerciseList] = useState<ExerciseObj[]>([]);
  const [activeExercise, setActiveExercise] = useState<ExerciseObj | undefined>();
  useEffect(() => {
    onChange?.(exerciseList);
  }, [exerciseList]);
  useEffect(() => {
    if (Array.isArray(defaultValue)) {
      setExerciseList(
        defaultValue.map((item) => ({
          ...item,
          id: isEmpty(item.id) ? create32LengthUUID() : item.id,
        })),
      );
    }
  }, [defaultValue]);

  useEffect(() => {
    toggleIsFullScreen?.(visible);
  }, [visible]);

  return (
    <div className={styles.exercise_com}>
      <div className={styles.exercise_com_list}>
        <DragList<ExerciseObj>
          data={exerciseList}
          component={(item) => {
            const fixNum = Array.isArray(item.regularQuestion) ? item.regularQuestion.length : 0;
            const randomNum = get(item, 'selectedNums', 0);
            const reward = get(item, 'rewardPer', 0);
            return (
              <div className={styles.exercise_com_list_item}>
                <div>
                  <MenuOutlined />
                </div>
                <div className={styles.exercise_com_list_item_inner}>
                  <div>{item.title}</div>
                  <Space className={styles.row}>
                    <span>
                      固定题目数：
                      <span className="text-808696">{fixNum}</span>
                    </span>
                    <span>
                      随机题目数：
                      <span className="text-808696">{randomNum}</span>
                    </span>
                    <span>
                      每题奖励学分：
                      <span className="text-808696">{reward}</span>
                    </span>
                    <span>
                      合计奖励学分：
                      <span className="text-808696">{reward * (fixNum + randomNum)}</span>
                    </span>
                  </Space>
                </div>
                <Space>
                  <EditOutlined
                    onClick={() => {
                      setVisible(true);
                      setActiveExercise(item);
                    }}
                  />
                  <Popconfirm
                    title="确定删除该习题分类吗？此修改节点保存后才生效"
                    okType="danger"
                    onConfirm={() => {
                      const idx = exerciseList.findIndex(
                        (exerciseListItem) => exerciseListItem.id === item.id,
                      );
                      if (idx > -1) {
                        setExerciseList((prevState) => {
                          prevState.splice(idx, 1);
                          return [...prevState];
                        });
                      }
                    }}
                    okText="删除"
                    cancelText="取消"
                  >
                    <DeleteOutlined />
                  </Popconfirm>
                </Space>
              </div>
            );
          }}
          onDragEnd={(data) => {
            const temp = [];
            for (let i = 0; i < data.length; i++) {
              const id = data[i].id;
              const find = exerciseList.find((item) => item.id === id);
              if (find) {
                temp.push(find);
              }
            }
            setExerciseList(temp);
          }}
        />
      </div>
      <div className={styles.exercise_com_footer}>
        <Button
          type="link"
          icon={<PlusSquareOutlined />}
          onClick={() => {
            setVisible(true);
            setActiveExercise(undefined);
          }}
        >
          添加抽题规则
        </Button>
      </div>
      {visible && (
        <ExerciseModal
          activeExercise={activeExercise}
          visible={visible}
          onOk={(data) => {
            console.log('接收到数据');
            console.log(data);
            console.log(exerciseList);
            const idx = exerciseList.findIndex((item) => item.id === data.id);
            if (idx > -1) {
              setExerciseList((prevState) => {
                prevState.splice(idx, 1, { ...data });
                return [...prevState];
              });
            } else {
              setExerciseList((prevState) => {
                prevState.push(data);
                return [...prevState];
              });
            }
            setVisible(false);
          }}
          onCancel={() => {
            setVisible(false);
          }}
        />
      )}
    </div>
  );
};
export default ExerciseCom;
